import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function FrustrationMethodSection() {
  const benefits = ['Vuelve a comer pan, pizza y dulces sin gluten… sin inflamación y sin fallar en el intento', 'Resultados esponjosos, con sabor real y sin picos de azúcar', 'Resultados desde el primer intento sin desperdiciar ingredientes ni dinero', 'Ingredientes accesibles que puedes conseguir fácilmente'];
  return <section className="py-10 md:py-14 px-4 bg-[#FFFBEB]" data-id="element-93">
      <div className="max-w-xl mx-auto" data-id="element-94">
        {/* Headline */}
        <div className="text-center mb-6" data-id="element-95">
          <h2 className="md:text-[22px] text-gray-900 text-[18px] font-[800] font-[Poppins,_sans-serif]" data-id="element-96">
            Esto es lo que te permite volver a comer lo que te gusta… sin
            consecuencias
          </h2>
          <p className="text-[14px] md:text-[16px] text-gray-600 mt-2 leading-relaxed" data-id="element-97">
            Un sistema paso a paso que elimina el error y hace que te salga bien
            desde el primer intento
          </p>
        </div>

        {/* Benefit List */}
        <div className="space-y-3" data-id="element-98">
          {benefits.map((benefit, index) => <div key={index} className="bg-white border border-[#E8F5E9] rounded-lg px-4 py-3.5 flex items-start gap-3" data-id="element-99">
              <CheckCircle2 className="w-5 h-5 text-[#22C55E] flex-shrink-0 mt-0.5" data-id="element-100" />
              <p className="text-[15px] md:text-base text-gray-800 font-medium leading-snug" data-id="element-101">
                {benefit}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}